<template>
  <div class="main-container">
    <div v-if="userPlatform === 2" class="argee-content" v-html="vhtml"></div>
    <div v-if="userPlatform !== 2" class="argee-content" v-html="vsmhtml"></div>

  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      vsmhtml:`
        <p style="text-align: center" >隐私政策</p>

<p style="text-align: center" >更新日期：2022年9月5日</p>
<p style="text-align: center" >生效日期：2022年9月5日</p>

<p>尊敬的用户：</p>
<p>您好！</p>
<p>北京百川盈孚科技有限公司（以下简称&ldquo;百川盈孚&rdquo;或&ldquo;我们&rdquo;）非常注重保护用户（&ldquo;您&rdquo;）的个人信息及隐私，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们致力于维持您对我们的信任，恪守合法正当、最小必要、公开透明等原则，保护您的个人信息安全。希望通过本隐私政策向您清晰地介绍在使用我们的产品/服务时，我们如何处理您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式。</p>

<p>百川盈孚隐私政策（以下称&ldquo;本隐私政策&rdquo;）适用于百川盈孚的所有产品或服务。如果某款产品有单独的隐私政策，则该产品的隐私政策优先使用。该产品隐私政策未涵盖的内容，以本隐私政策为准。</p>

<p><strong><strong>【特别提示】请您在使用我们提供的各项产品/服务前，仔细阅读并充分理解本《隐私政策》（重点内容我们已将字体加粗请您特别关注）并作出相应选择。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。</strong></strong></p>

<p><strong><strong>如对本隐私政策有任何疑问，您可以通过本隐私政策&ldquo;如何联系我们&rdquo;中提供的联系方式与我们联系）。</strong></strong></p>

<p><strong><strong>本隐私政策将帮助您了解以下内容： </strong></strong></p>

<p><strong><strong>1、我们如何收集和使用您的个人信息 </strong></strong></p>

<p><strong><strong>2、我们如何保护您的个人信息 </strong></strong></p>

<p><strong><strong>3、我们如何使用Cookie和同类技术 </strong></strong></p>

<p><strong><strong>4、我们如何共享、转让、公开披露您的个人信息 </strong></strong></p>

<p><strong><strong>5、您的权利 </strong></strong></p>

<p><strong><strong>6、通知和修订 </strong></strong></p>

<p><strong><strong>7、如何联系我们 </strong></strong></p>


<p><strong><strong>一、我们如何收集和使用您的个人信息</strong></strong></p>

<p>根据《中华人民共和国个人信息保护法》的规定，个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。我们将根据合法正当、最小必要、公开透明的原则，仅收集实现产品功能或服务所必要的信息。<strong><strong>我们会根据如下使用需要收集您的信息：</strong></strong>&nbsp;</p>

<p><strong><strong>（一）帮助您注册成为我们的用户</strong></strong></p>

<p>为完成注册账号，您需提供以下信息：<strong><strong>您的移动电话、创建的用户名和密码、邮箱、真实姓名、性别、单位名称。</strong></strong>我们收集这些信息是为了帮您顺利完成注册流程、为您持续稳定的提供专属于该注册账号的产品或服务。</p>

<p><strong><strong>（二）向您提供产品和服务</strong></strong></p>

<p>1、当您使用我们的产品或服务时，我们会收集以下信息：</p>

<p>（1）为了保障您的账号安全，我们会收集您的<strong><strong>浏览器类型及版本信息</strong></strong>。我们收集这些信息是为了防止恶意程序，应对反作弊、反欺诈、违法不良信息管控等安全风险防控要求。</p>

<p>（2）当您在使用我们的产品时，我们的服务器会自动记录一些信息，自动生成<strong><strong>日志信息</strong></strong>。日志信息包括您对我们产品的使用情况、浏览的内容、访问服务的日期、时间、时长。我们收集这些信息仅用于进行数据统计、分析，以提升我们的产品或服务质量。</p>

<p>（3）当您在使用我们的产品时，我们将会收集您的<strong><strong>网络IP地址</strong></strong>。我们收集这些信息为了确保网络安全，以保护信息数据及客户资料的安全。</p>

<p>（4）当您通过电话与我们的客服互动时，为了您的账户安全，我们将需要您<strong><strong>提供帐号信息及其他个人信息以验证您的身份</strong></strong>。我们收集这些信息是为了调查事实并更好的帮助您解决问题。</p>


<p>2、您理解并知悉，您向外部第三方提供的个人信息，或外部第三方收集您的个人信息，我们无法获取，更不会使用非常规方式擅自获取您的个人信息。如因业务发展需要，我们可能会从第三方合作伙伴收集您的个人信息。<strong><strong>我们在收集前会向您明示共享您个人信息的来源、使用目的、方式、授权同意范围。请您仔细阅读第三方合作伙伴服务的用户协议或隐私政策。 </strong></strong></p>

<p>3、为更好地为您提供产品或服务，在您使用本产品的过程中，<strong><strong>我们可能需要获取您的部分敏感个人信息。在收集此类信息前，我们会向您说明收集的目的、方式、使用范围，并单独取得您的同意。</strong></strong>&nbsp;</p>

<p>根据《中华人民共和国个人信息保护法》的规定，敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>

<p><strong><strong>（三）您提供的上述个人信息，将在您使用本产品或服务期间持续授权我们使用。在您注销账号时，我们将停止使用上述信息。在您注销账号或服务到期后，上述信息将依据《民事诉讼法》等相关法律法规的要求至少保存三年。 </strong></strong></p>


<p><strong><strong>您提供的个人信息将存储于中华人民共和国境内。如果因业务需求、政府和司法监管要求存在跨境信息传输情况，我们将告知您需要进行跨境传输的数据类型，以及跨境传输遵守的标准、协议和法律机制等事项</strong></strong>，<strong><strong>并单独取得您的同意</strong></strong>。</p>

<p>当我们要将上述个人信息用于本隐私政策未载明的其它用途时，<strong><strong>会事先征求您的同意</strong></strong>。当我们要将基于特定目的收集而来的信息用于其他目的时，<strong><strong>也会事先征求您的同意</strong></strong>。</p>

<p><strong><strong>（四）例外 </strong></strong></p>

<p>在下列情况下，我们收集、使用您的个人信息无需取得您的同意：</p>

<p>1、与国家安全、国防安全直接相关的；</p>

<p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>

<p>3、紧急情况下出于维护您或其他个人的生命、财产等重大合法权益所必需但又很难获得本人同意的；</p>

<p>4、个人信息是您自行向社会公开的或者是我们从合法公开披露的渠道中收集到的；</p>

<p>5、个人信息是为订立、履行合同所必需的；</p>

<p>6、其他与我们履行法律法规规定的义务相关的。</p>


<p><strong><strong>二、我们如何保护您的个人信息</strong></strong></p>

<p>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。<strong><strong>我们会采取一切合理可行的措施，保护您的个人信息。</strong></strong>我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。授权人员均受保密义务的约束，如授权人员违反保密义务，将承担相应的法律责任。</p>

<p>（二）<strong><strong>我们的数据安全能力：</strong></strong>公司内设置网络信息安全人员，专门负责公司网络安全，保护公司数据及客户资料不被非法获取；并制定了完善的数据安全制度规范和流程；软硬件方面有堡垒机制和应用防火墙可以有效的阻止外部及内部入侵；技术部的成员对网络硬件，应用平台以及操作系统都有深入理解，有能力处理突发的外部安全事件。</p>

<p>（三）我们会采取一切合理可行的措施，确保未收集无关的个人信息。<strong><strong>我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。 </strong></strong></p>

<p>（四）互联网并非绝对安全的环境，而且电子邮件、即时通讯的交流方式并未加密，<strong><strong>我们强烈建议您不要通过此类方式发送个人信息。</strong></strong>请使用复杂密码，协助我们保证您的账号安全。</p>

<p>（五）互联网环境并非百分之百安全，<strong><strong>我们将尽力确保或担保您发送给我们的任何信息的安全性。</strong></strong>如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>

<p>（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，<strong><strong>及时向您告知</strong></strong>：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>

<p>（七）关于儿童的个人信息，如果没有父母或监护人的同意，<strong><strong>儿童不得创建自己的用户账户</strong></strong>。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>


<p><strong><strong>三、我们如何使用Cookie和同类技术 </strong></strong></p>

<p><strong><strong>（一）Cookie </strong></strong></p>

<p>为了更好的用户体验，我们通过 Cookie 保存一些用户使用习惯及网站的一些号码和字符。我们不会将Cookie 用于本隐私政策之外的任何用途。您可根据自己的偏好管理或删除Cookie。如果您清除计算机上保存的所有Cookie，则需要您在每次登录使用我们网站亲自更改用户设置。</p>

<p>我们会通过cookie或其它应用程序提供的本地存储等一系列小型数据文件识别您的身份，我通过访问某些Cookie用以提升您的体验。以上服务均基于您浏览器或浏览器附加服务允许的情况下实现，如您想修改对cookies的接受程度或拒绝我们网站的Cookie，您可以通过改变您浏览器附加程序的设置，或通过访问提供商的网页来关闭或删除Cookie，但这一操作在某些情况下可能会影响您安全访问网站和使用网站提供的服务。</p>

<p><strong><strong>（二）同类技术</strong></strong></p>

<p>为了为用户提供更好更细致的服务，我们通过脚本技术记录各个产品功能在用户中的受欢迎程度。</p>

<p><strong><strong>四、我们如何共享、转让、公开披露您的个人信息</strong></strong></p>

<p><strong><strong>（一）共享 </strong></strong></p>

<p>我们不会与百川盈孚以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>

<p>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>

<p>2、我们可能会根据法律法规规定，或按政府监管部门的强制性要求，对外共享您的个人信息。</p>

<p>3、与我们的分子公司共享：您的个人信息可能会与百川盈孚的分子公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的分子公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>

<p>4、与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</p>

<p>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协议，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>



<p><strong><strong>（二）转让</strong></strong></p>

<p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>

<p>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</p>

<p>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>

<p><strong><strong>（三）公开披露</strong></strong></p>

<p>我们仅会在以下情况下，公开披露您的个人信息：</p>

<p>1、<strong><strong>获得您明确同意后</strong></strong>；</p>

<p>2、<strong><strong>基于法律法规、法律程序、诉讼或政府监管部门的强制性要求下</strong></strong>。</p>

<p><strong><strong>（四）共享、转让、公开披露您的个人信息时事先获取同意的例外</strong></strong></p>

<p>未经您本人同意，我们不会向第三方共享、转让、公开披露您的个人信息，下列情形除外：</p>

<p>1、与国家安全、国防安全直接相关的；</p>

<p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>

<p>3、与诉讼、仲裁、执行等法律程序直接相关的；或根据法律法规的要求、行政机关或公检法等机关的要求的；</p>

<p>4、紧急情况下出于维护您或其他个人的生命、财产等重大合法权益所必需但又很难获得本人同意的；</p>

<p>5、个人信息是您自行向社会公开的或者是我们从合法公开披露的渠道中收集到的；</p>

<p>6、个人信息是为订立、履行合同所必需的；</p>

<p>7、其他与我们履行法律法规规定的义务相关的。</p>


<p><strong><strong>五、您的权利</strong></strong></p>

<p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>

<p><strong><strong>（一）访问您的个人信息 </strong></strong></p>

<p>您有权访问您的个人信息，法律法规规定的例外情况除外。</p>

<p>如果您想行使数据访问权，你可以<strong><strong>联系您的业务员</strong></strong>对您的联系方式购买产品用户名称等个人信息进行更改。您也可以通过电话或电子邮件等方式联系我们。在验证您的身份后，我们将在10个工作日内回复您的修改请求。对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请您通过电子邮件等方式联系我们。</p>

<p><strong><strong>（二）更正您的个人信息 </strong></strong></p>

<p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过电话或电子邮件等方式提出更正申请。我们将在<strong><strong>10</strong></strong><strong><strong>个工作日内</strong></strong>回复您的更正请求。</p>

<p><strong><strong>（三）删除您的个人信息 </strong></strong></p>

<p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>

<p>1、如果我们处理个人信息的行为违反法律法规。</p>

<p>2、如果我们收集、使用您的个人信息，却未征得您的同意。</p>

<p>3、如果我们处理个人信息的行为违反了与您的约定。</p>

<p>4、如果您不再使用我们的产品或服务，或您注销了账号。</p>

<p>5、如果我们不再为您提供产品或服务。</p>

<p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>

<p>当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但<strong><strong>会在备份更新时删除这些信息</strong></strong>。</p>

<p><strong><strong>（四）改变您授权同意的范围 </strong></strong></p>

<p>每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以通过电话或电子邮件等方式随时给予或收回您的授权同意。</p>

<p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>

<p>如果您不想接受我们给您发送的商业广告，您随时可通过电话或电子邮件等方式取消。</p>

<p><strong><strong>（五）个人信息主体注销账户 </strong></strong></p>

<p>您可以通过拨打我们客服电话或电子邮件等方式通知我们注销此前注册的账户，在注销账户之后，我们将停止为您提供产品或服务，并按照法律法规要求尽快删除相应的信息，但部分信息可能由于技术原因无法实现彻底删除。无法删除时我们承诺停止除存储和采取必要的安全保护措施之外的处理，法律法规另有规定的除外。</p>

<p><strong><strong>（六）个人信息主体获取个人信息副本 </strong></strong></p>

<p>您可以通过电话或电子邮件等方式通知我们获取您的个人信息副本。</p>

<p><strong><strong>（七）响应您的上述请求 </strong></strong></p>

<p>为保障您的账户安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们会先要求您验证自己的身份，然后再处理您的请求。</p>

<p>我们将在<strong><strong>10个工作日内</strong></strong>做出答复。</p>

<p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>

<p><strong><strong>在以下情形中，按照法律法规要求，我们将无法响应您的请求： </strong></strong></p>

<p>1、与国家安全、国防安全直接相关的;</p>

<p>2、与公共安全、公共卫生、重大公共利益直接相关的;</p>

<p>3、与诉讼、仲裁、执行等法律程序直接相关的；或根据法律法规的要求、行政机关或公检法等机关的要求的；</p>

<p>4、有充分证据表明您存在主观恶意或滥用权利的;</p>

<p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的;</p>

<p>6、涉及商业秘密的。</p>

<p><strong><strong>六、通知和修订 </strong></strong></p>

<p>为了给您提供更好地服务，我们会根据产品的更新情况及法律法规的要求更新本政策的条款。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本隐私政策所做的任何变更。</p>

<p>对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>

<p><strong><strong>本隐私政策所指的重大变更包括但不限于</strong></strong>：</p>

<p>1、我们的服务模式发生重大变化。</p>

<p>2、我们在所有权结构、组织架构等方面发生重大变化。</p>

<p>3、个人信息共享、转让或公开披露的主要对象发生变化。</p>

<p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化。</p>

<p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化。</p>

<p>6、个人信息安全影响评估报告表明存在高风险。</p>

<p>为更好的提供信息服务，根据用户需求、业务规则以及法律法规的要求，我们会适时对本政策的相关条款进行修订。如我们对本政策进行了修订，我们将会在个人信息主体使用网站时，<strong><strong>通过弹出窗口的方式通知您</strong></strong>。</p>

<p><strong><strong>七、如何联系我们 </strong></strong></p>

<p>如果您对本隐私政策有任何疑问、意见或建议，您可以通过以下方式与我们联系：</p>

<p>1、您可以通过百川盈孚网站（www.baiinfo.com）上提供的邮箱（xwg@baiinfo.com）与我们联系；</p>

<p>2、您可以联系百川盈孚的客服电话进行反馈（客服热线:010-59795659）；</p>

<p>3、或者您也可以寄信到如下地址： 北京市东城区东直门外大街39号院2号楼航空服务楼5层501A（收），邮编： 100028。</p>

<p>一般情况下，我们将在<strong><strong>1</strong></strong><strong><strong>0</strong></strong><strong><strong>个工作日内</strong></strong>回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或通过向<strong><strong>百川盈孚住所地有管辖权的法院提起诉讼</strong></strong>来寻求解决方案。</p>
      `,
      vhtml: `
<p style="text-align: center" >隐私政策</p>

<p style="text-align: right" >更新日期：2022年9月5日</p>
<p style="text-align: right" >生效日期：2022年9月5日</p>

<p>尊敬的用户：</p>
<p>您好！</p>
<p>北京百川盈孚科技有限公司（以下简称&ldquo;百川盈孚&rdquo;或&ldquo;我们&rdquo;）非常注重保护用户（&ldquo;您&rdquo;）的个人信息及隐私，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们致力于维持您对我们的信任，恪守合法正当、最小必要、公开透明等原则，保护您的个人信息安全。希望通过本隐私政策向您清晰地介绍在使用我们的产品/服务时，我们如何处理您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式。</p>

<p>百川盈孚隐私政策（以下称&ldquo;本隐私政策&rdquo;）适用于百川盈孚的所有产品或服务。如果某款产品有单独的隐私政策，则该产品的隐私政策优先使用。该产品隐私政策未涵盖的内容，以本隐私政策为准。</p>

<p><strong><strong>【特别提示】请您在使用我们提供的各项产品/服务前，仔细阅读并充分理解本《隐私政策》（重点内容我们已将字体加粗请您特别关注）并作出相应选择。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。</strong></strong></p>

<p><strong><strong>如对本隐私政策有任何疑问，您可以通过本隐私政策&ldquo;如何联系我们&rdquo;中提供的联系方式与我们联系）。</strong></strong></p>

<p><strong><strong>本隐私政策将帮助您了解以下内容： </strong></strong></p>

<p><strong><strong>1、我们如何收集和使用您的个人信息 </strong></strong></p>

<p><strong><strong>2、我们如何保护您的个人信息 </strong></strong></p>

<p><strong><strong>3、我们如何使用Cookie和同类技术 </strong></strong></p>

<p><strong><strong>4、我们如何共享、转让、公开披露您的个人信息 </strong></strong></p>

<p><strong><strong>5、您的权利 </strong></strong></p>

<p><strong><strong>6、通知和修订 </strong></strong></p>

<p><strong><strong>7、如何联系我们 </strong></strong></p>


<p><strong><strong>一、我们如何收集和使用您的个人信息</strong></strong></p>

<p>根据《中华人民共和国个人信息保护法》的规定，个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。我们将根据合法正当、最小必要、公开透明的原则，仅收集实现产品功能或服务所必要的信息。<strong><strong>我们会根据如下使用需要收集您的信息：</strong></strong>&nbsp;</p>

<p><strong><strong>（一）帮助您注册成为我们的用户</strong></strong></p>

<p>为完成注册账号，您需提供以下信息：<strong><strong>您的移动电话、创建的用户名和密码、邮箱、真实姓名、性别、单位名称。</strong></strong>我们收集这些信息是为了帮您顺利完成注册流程、为您持续稳定的提供专属于该注册账号的产品或服务。</p>

<p><strong><strong>（二）向您提供产品和服务</strong></strong></p>

<p>1、当您使用我们的产品或服务时，我们会收集以下信息：</p>

<p>（1）为了保障您的账号安全，我们会收集您的<strong><strong>浏览器类型及版本信息</strong></strong>。我们收集这些信息是为了防止恶意程序，应对反作弊、反欺诈、违法不良信息管控等安全风险防控要求。</p>

<p>（2）当您在使用我们的产品时，我们的服务器会自动记录一些信息，自动生成<strong><strong>日志信息</strong></strong>。日志信息包括您对我们产品的使用情况、浏览的内容、访问服务的日期、时间、时长。我们收集这些信息仅用于进行数据统计、分析，以提升我们的产品或服务质量。</p>

<p>（3）当您在使用我们的产品时，我们将会收集您的<strong><strong>网络IP地址</strong></strong>。我们收集这些信息为了确保网络安全，以保护信息数据及客户资料的安全。</p>

<p>（4）当您通过电话与我们的客服互动时，为了您的账户安全，我们将需要您<strong><strong>提供帐号信息及其他个人信息以验证您的身份</strong></strong>。我们收集这些信息是为了调查事实并更好的帮助您解决问题。</p>


<p>2、您理解并知悉，您向外部第三方提供的个人信息，或外部第三方收集您的个人信息，我们无法获取，更不会使用非常规方式擅自获取您的个人信息。如因业务发展需要，我们可能会从第三方合作伙伴收集您的个人信息。<strong><strong>我们在收集前会向您明示共享您个人信息的来源、使用目的、方式、授权同意范围。请您仔细阅读第三方合作伙伴服务的用户协议或隐私政策。 </strong></strong></p>

<p>3、为更好地为您提供产品或服务，在您使用本产品的过程中，<strong><strong>我们可能需要获取您的部分敏感个人信息。在收集此类信息前，我们会向您说明收集的目的、方式、使用范围，并单独取得您的同意。</strong></strong>&nbsp;</p>

<p>根据《中华人民共和国个人信息保护法》的规定，敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>

<p><strong><strong>（三）您提供的上述个人信息，将在您使用本产品或服务期间持续授权我们使用。在您注销账号时，我们将停止使用上述信息。在您注销账号或服务到期后，上述信息将依据《民事诉讼法》等相关法律法规的要求至少保存三年。 </strong></strong></p>


<p><strong><strong>您提供的个人信息将存储于中华人民共和国境内。如果因业务需求、政府和司法监管要求存在跨境信息传输情况，我们将告知您需要进行跨境传输的数据类型，以及跨境传输遵守的标准、协议和法律机制等事项</strong></strong>，<strong><strong>并单独取得您的同意</strong></strong>。</p>

<p>当我们要将上述个人信息用于本隐私政策未载明的其它用途时，<strong><strong>会事先征求您的同意</strong></strong>。当我们要将基于特定目的收集而来的信息用于其他目的时，<strong><strong>也会事先征求您的同意</strong></strong>。</p>

<p><strong><strong>（四）例外 </strong></strong></p>

<p>在下列情况下，我们收集、使用您的个人信息无需取得您的同意：</p>

<p>1、与国家安全、国防安全直接相关的；</p>

<p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>

<p>3、紧急情况下出于维护您或其他个人的生命、财产等重大合法权益所必需但又很难获得本人同意的；</p>

<p>4、个人信息是您自行向社会公开的或者是我们从合法公开披露的渠道中收集到的；</p>

<p>5、个人信息是为订立、履行合同所必需的；</p>

<p>6、其他与我们履行法律法规规定的义务相关的。</p>


<p><strong><strong>二、我们如何保护您的个人信息</strong></strong></p>

<p>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。<strong><strong>我们会采取一切合理可行的措施，保护您的个人信息。</strong></strong>我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。授权人员均受保密义务的约束，如授权人员违反保密义务，将承担相应的法律责任。</p>

<p>（二）<strong><strong>我们的数据安全能力：</strong></strong>公司内设置网络信息安全人员，专门负责公司网络安全，保护公司数据及客户资料不被非法获取；并制定了完善的数据安全制度规范和流程；软硬件方面有堡垒机制和应用防火墙可以有效的阻止外部及内部入侵；技术部的成员对网络硬件，应用平台以及操作系统都有深入理解，有能力处理突发的外部安全事件。</p>

<p>（三）我们会采取一切合理可行的措施，确保未收集无关的个人信息。<strong><strong>我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。 </strong></strong></p>

<p>（四）互联网并非绝对安全的环境，而且电子邮件、即时通讯的交流方式并未加密，<strong><strong>我们强烈建议您不要通过此类方式发送个人信息。</strong></strong>请使用复杂密码，协助我们保证您的账号安全。</p>

<p>（五）互联网环境并非百分之百安全，<strong><strong>我们将尽力确保或担保您发送给我们的任何信息的安全性。</strong></strong>如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>

<p>（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，<strong><strong>及时向您告知</strong></strong>：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>

<p>（七）关于儿童的个人信息，如果没有父母或监护人的同意，<strong><strong>儿童不得创建自己的用户账户</strong></strong>。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>


<p><strong><strong>三、我们如何使用Cookie和同类技术 </strong></strong></p>

<p><strong><strong>（一）Cookie </strong></strong></p>

<p>为了更好的用户体验，我们通过 Cookie 保存一些用户使用习惯及网站的一些号码和字符。我们不会将Cookie 用于本隐私政策之外的任何用途。您可根据自己的偏好管理或删除Cookie。如果您清除计算机上保存的所有Cookie，则需要您在每次登录使用我们网站亲自更改用户设置。</p>

<p>我们会通过cookie或其它应用程序提供的本地存储等一系列小型数据文件识别您的身份，我通过访问某些Cookie用以提升您的体验。以上服务均基于您浏览器或浏览器附加服务允许的情况下实现，如您想修改对cookies的接受程度或拒绝我们网站的Cookie，您可以通过改变您浏览器附加程序的设置，或通过访问提供商的网页来关闭或删除Cookie，但这一操作在某些情况下可能会影响您安全访问网站和使用网站提供的服务。</p>

<p><strong><strong>（二）同类技术</strong></strong></p>

<p>为了为用户提供更好更细致的服务，我们通过脚本技术记录各个产品功能在用户中的受欢迎程度。</p>

<p><strong><strong>四、我们如何共享、转让、公开披露您的个人信息</strong></strong></p>

<p><strong><strong>（一）共享 </strong></strong></p>

<p>我们不会与百川盈孚以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>

<p>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>

<p>2、我们可能会根据法律法规规定，或按政府监管部门的强制性要求，对外共享您的个人信息。</p>

<p>3、与我们的分子公司共享：您的个人信息可能会与百川盈孚的分子公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的分子公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>

<p>4、与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</p>

<p>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协议，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>



<p><strong><strong>（二）转让</strong></strong></p>

<p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>

<p>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</p>

<p>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>

<p><strong><strong>（三）公开披露</strong></strong></p>

<p>我们仅会在以下情况下，公开披露您的个人信息：</p>

<p>1、<strong><strong>获得您明确同意后</strong></strong>；</p>

<p>2、<strong><strong>基于法律法规、法律程序、诉讼或政府监管部门的强制性要求下</strong></strong>。</p>

<p><strong><strong>（四）共享、转让、公开披露您的个人信息时事先获取同意的例外</strong></strong></p>

<p>未经您本人同意，我们不会向第三方共享、转让、公开披露您的个人信息，下列情形除外：</p>

<p>1、与国家安全、国防安全直接相关的；</p>

<p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>

<p>3、与诉讼、仲裁、执行等法律程序直接相关的；或根据法律法规的要求、行政机关或公检法等机关的要求的；</p>

<p>4、紧急情况下出于维护您或其他个人的生命、财产等重大合法权益所必需但又很难获得本人同意的；</p>

<p>5、个人信息是您自行向社会公开的或者是我们从合法公开披露的渠道中收集到的；</p>

<p>6、个人信息是为订立、履行合同所必需的；</p>

<p>7、其他与我们履行法律法规规定的义务相关的。</p>


<p><strong><strong>五、您的权利</strong></strong></p>

<p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>

<p><strong><strong>（一）访问您的个人信息 </strong></strong></p>

<p>您有权访问您的个人信息，法律法规规定的例外情况除外。</p>

<p>如果您想行使数据访问权，你可以<strong><strong>联系您的业务员</strong></strong>对您的联系方式购买产品用户名称等个人信息进行更改。您也可以通过电话或电子邮件等方式联系我们。在验证您的身份后，我们将在10个工作日内回复您的修改请求。对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请您通过电子邮件等方式联系我们。</p>

<p><strong><strong>（二）更正您的个人信息 </strong></strong></p>

<p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过电话或电子邮件等方式提出更正申请。我们将在<strong><strong>10</strong></strong><strong><strong>个工作日内</strong></strong>回复您的更正请求。</p>

<p><strong><strong>（三）删除您的个人信息 </strong></strong></p>

<p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>

<p>1、如果我们处理个人信息的行为违反法律法规。</p>

<p>2、如果我们收集、使用您的个人信息，却未征得您的同意。</p>

<p>3、如果我们处理个人信息的行为违反了与您的约定。</p>

<p>4、如果您不再使用我们的产品或服务，或您注销了账号。</p>

<p>5、如果我们不再为您提供产品或服务。</p>

<p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>

<p>当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但<strong><strong>会在备份更新时删除这些信息</strong></strong>。</p>

<p><strong><strong>（四）改变您授权同意的范围 </strong></strong></p>

<p>每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以通过电话或电子邮件等方式随时给予或收回您的授权同意。</p>

<p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>

<p>如果您不想接受我们给您发送的商业广告，您随时可通过电话或电子邮件等方式取消。</p>

<p><strong><strong>（五）个人信息主体注销账户 </strong></strong></p>

<p>您可以通过拨打我们客服电话或电子邮件等方式通知我们注销此前注册的账户，在注销账户之后，我们将停止为您提供产品或服务，并按照法律法规要求尽快删除相应的信息，但部分信息可能由于技术原因无法实现彻底删除。无法删除时我们承诺停止除存储和采取必要的安全保护措施之外的处理，法律法规另有规定的除外。</p>

<p><strong><strong>（六）个人信息主体获取个人信息副本 </strong></strong></p>

<p>您可以通过电话或电子邮件等方式通知我们获取您的个人信息副本。</p>

<p><strong><strong>（七）响应您的上述请求 </strong></strong></p>

<p>为保障您的账户安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们会先要求您验证自己的身份，然后再处理您的请求。</p>

<p>我们将在<strong><strong>10个工作日内</strong></strong>做出答复。</p>

<p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>

<p><strong><strong>在以下情形中，按照法律法规要求，我们将无法响应您的请求： </strong></strong></p>

<p>1、与国家安全、国防安全直接相关的;</p>

<p>2、与公共安全、公共卫生、重大公共利益直接相关的;</p>

<p>3、与诉讼、仲裁、执行等法律程序直接相关的；或根据法律法规的要求、行政机关或公检法等机关的要求的；</p>

<p>4、有充分证据表明您存在主观恶意或滥用权利的;</p>

<p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的;</p>

<p>6、涉及商业秘密的。</p>

<p><strong><strong>六、通知和修订 </strong></strong></p>

<p>为了给您提供更好地服务，我们会根据产品的更新情况及法律法规的要求更新本政策的条款。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本隐私政策所做的任何变更。</p>

<p>对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>

<p><strong><strong>本隐私政策所指的重大变更包括但不限于</strong></strong>：</p>

<p>1、我们的服务模式发生重大变化。</p>

<p>2、我们在所有权结构、组织架构等方面发生重大变化。</p>

<p>3、个人信息共享、转让或公开披露的主要对象发生变化。</p>

<p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化。</p>

<p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化。</p>

<p>6、个人信息安全影响评估报告表明存在高风险。</p>

<p>为更好的提供信息服务，根据用户需求、业务规则以及法律法规的要求，我们会适时对本政策的相关条款进行修订。如我们对本政策进行了修订，我们将会在个人信息主体使用网站时，<strong><strong>通过弹出窗口的方式通知您</strong></strong>。</p>

<p><strong><strong>七、如何联系我们 </strong></strong></p>

<p>如果您对本隐私政策有任何疑问、意见或建议，您可以通过以下方式与我们联系：</p>

<p>1、您可以通过百川盈孚网站（www.baiinfo.com）上提供的邮箱（xwg@baiinfo.com）与我们联系；</p>

<p>2、您可以联系百川盈孚的客服电话进行反馈（客服热线:010-59795659）；</p>

<p>3、或者您也可以寄信到如下地址： 北京市东城区东直门外大街39号院2号楼航空服务楼5层501A（收），邮编： 100028。</p>

<p>一般情况下，我们将在<strong><strong>1</strong></strong><strong><strong>0</strong></strong><strong><strong>个工作日内</strong></strong>回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或通过向<strong><strong>百川盈孚住所地有管辖权的法院提起诉讼</strong></strong>来寻求解决方案。</p>

`,
    };
  },
    computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
    })
    }
};
</script>

<style lang="scss" scoped>
.argee-content {
  padding: 40px 10px;
  color: #333333;
  /deep/ p {
    margin-bottom: 0.5em;
  }

  /deep/ .content-head-time {
    text-align: center;
  }
}
@media (min-width: 1024px) {
  .argee-content {
    /deep/.content-head-time {
      text-align: right;
    }
  }
}
</style>